import { render, staticRenderFns } from "./HistoricProduction.vue?vue&type=template&id=df8a40ec&"
import script from "./HistoricProduction.vue?vue&type=script&lang=js&"
export * from "./HistoricProduction.vue?vue&type=script&lang=js&"
import style0 from "./HistoricProduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports